import { Stack } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";
import { SHIFT_DISCOVERY_LIST_PATH } from "@src/appV2/redesign/ShiftDiscovery/paths";
import { Text, Title } from "@src/appV2/redesign/system/ui-components";

import { Button } from "../../components/Button";

interface ShiftHistoryEmptyStateProps {
  filtersAreApplied: boolean;
}

export function ShiftHistoryEmptyState(props: ShiftHistoryEmptyStateProps) {
  const { filtersAreApplied } = props;

  return (
    <Stack
      sx={{
        flex: 1,
        flexGrow: 1,
        alignItems: "center",
      }}
      justifyContent="center"
      spacing={5}
    >
      <Title semibold variant="h4" component="h3" sx={{ textWrap: "balance", textAlign: "center" }}>
        {filtersAreApplied ? "No shifts match your filters" : "You haven't worked any shifts yet"}
      </Title>
      <Text
        semibold
        textAlign="center"
        variant="body2"
        sx={{ paddingBottom: 8, textWrap: "balance" }}
      >
        {filtersAreApplied
          ? "Try updating your filters to see more shifts"
          : "Browse available shifts at facilities near you to get started"}
      </Text>
      <Button variant="contained" href={`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}`}>
        Browse Shifts
      </Button>
    </Stack>
  );
}
